/* Discover Mimi section, Designer Bathware.
   Loads nothing until the section is near the screen, then fetches only the
   current product type from Shopify. Pauses when off screen. */
(function () {
  'use strict';

  var ICON = {
    cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10.6 1.8h2.8v3.4h-2.8z"/><path d="M11.3 2.2v2.6M12 2.2v2.6M12.7 2.2v2.6"/><path d="M9 5.2h6v1.6H9z"/><path d="M8 6.8h8v10.4H8z"/><path d="M8 9.3h8M8 14.6h8"/><path d="M6.6 17.2h10.8v2.2H6.6z"/><circle cx="10" cy="21" r=".9"/><circle cx="14" cy="21" r=".9"/></svg>',
    life: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg>',
    finish: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3c3 4 6 7 6 11a6 6 0 0 1-12 0c0-4 3-7 6-11z"/><path d="M9.5 14.5a2.5 2.5 0 0 0 2.5 2.5"/></svg>',
    match: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="8" cy="12" r="4"/><circle cx="16" cy="12" r="4"/></svg>',
    stock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>'
  };
  var CARET = '<svg class="md-car" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  var PAUSE = '<rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/>';
  var PLAY = '<path d="M8 5.5v13l10.5-6.5z"/>';
  var FINISH_WORDS = ['Warm Brushed Nickel', 'Brushed Nickel', 'Matte Black', 'Gun Metal', 'Gunmetal', 'Brushed Brass', 'Antique Brass', 'Chrome'];
  var money = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var productCache = {};

  function fetchProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }
  function sized(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function shortName(title) {
    var t = String(title || '').replace(/\s+/g, ' ').replace(/^Mimi\s+/i, '').trim();
    for (var i = 0; i < FINISH_WORDS.length; i++) {
      var re = new RegExp('\\s+' + FINISH_WORDS[i].replace(/ /g, '\\s+') + '$', 'i');
      if (re.test(t)) return t.replace(re, '').trim();
    }
    return t;
  }

  function init(el) {
    var cfg;
    try { cfg = JSON.parse(el.querySelector('[data-md-config]').textContent); } catch (e) { return; }
    var F = cfg.finishes, G = cfg.groups, INFO = cfg.info, DUR = cfg.dur || 2400;
    var q = function (s) { return el.querySelector(s); };
    var seg = q('[data-md-seg]'), pill = q('[data-md-pill]'), view = q('[data-md-view]'), rail = q('[data-md-rail]'),
        stage = q('[data-md-stage]'), fwrap = q('[data-md-fwrap]'), feats = q('[data-md-feats]'), pop = q('[data-md-pop]'),
        shop = q('[data-md-shop]'), sampleBtn = q('[data-md-sample]'), toggle = q('[data-md-toggle]'), plink = q('[data-md-plink]');
    var curItem = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var gi = 0, fi = 0, pi = 0, playing = !reduce, hover = false, onScreen = false, ready = false;
    var t0 = performance.now(), elapsed = 0, lastFn = null, hiStep = 0, badgeKey = '', openId = null, wasPlaying = false;
    var curImg = null, items = {}, started = false; // items[group][finish] = [{name, price, compare, url, img}]

    G.forEach(function (g, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('role', 'tab'); b.textContent = g.label;
      b.addEventListener('click', function () { setGroup(i); });
      // warm up a product type as soon as someone shows interest in its tab
      b.addEventListener('pointerenter', function () { if (started) loadGroup(i); });
      b.addEventListener('focus', function () { if (started) loadGroup(i); });
      seg.appendChild(b);
    });
    F.forEach(function (f, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('role', 'radio'); b.innerHTML = f.name + '<i></i>';
      b.addEventListener('click', function () { setPlay(false); pi = 0; setFinish(i, true); });
      rail.appendChild(b);
    });
    var segBtns = [].slice.call(seg.querySelectorAll('button')), railBtns = [].slice.call(rail.querySelectorAll('button'));

    function keepVisible(sc, b) { if (sc.scrollWidth > sc.clientWidth) sc.scrollTo({ left: b.offsetLeft - sc.clientWidth / 2 + b.offsetWidth / 2, behavior: 'smooth' }); }
    function movePill() { var b = segBtns[gi]; pill.style.width = b.offsetWidth + 'px'; pill.style.transform = 'translateX(' + b.offsetLeft + 'px)'; }
    function setBar(k) { railBtns.forEach(function (b, j) { b.querySelector('i').style.transform = 'scaleX(' + (j === fi ? k : 0) + ')'; }); }

    function loadGroup(i) {
      var g = G[i];
      if (items[i]) return items[i].promise;
      items[i] = {};
      var jobs = [];
      F.forEach(function (f) {
        var hs = (g.handles[f.id] || []);
        items[i][f.id] = new Array(hs.length);
        hs.forEach(function (h, k) {
          jobs.push(fetchProduct(h).then(function (p) {
            if (!p || !p.featured_image) return;
            var img = new Image();
            img.decoding = 'async'; img.width = 480; img.height = 480;
            img.alt = 'Mimi ' + shortName(p.title) + ' in ' + f.name;
            img.src = sized(p.featured_image, 480);
            view.appendChild(img);
            items[i][f.id][k] = { name: shortName(p.title), price: p.price, compare: p.compare_at_price, url: p.url, img: img, src: p.featured_image, hi: null };
            return img.decode ? img.decode().catch(function () {}) : null;
          }));
        });
      });
      items[i].promise = Promise.all(jobs).then(function () {
        F.forEach(function (f) { items[i][f.id] = items[i][f.id].filter(Boolean); });
      });
      return items[i].promise;
    }
    function list() { return (items[gi] && items[gi][F[fi].id]) || []; }

    function showImg(img) {
      if (!img || img === curImg) return;
      var old = curImg; curImg = img;
      img.classList.add('is-live');
      requestAnimationFrame(function () { requestAnimationFrame(function () { img.classList.add('is-on'); }); });
      if (old) { old.classList.remove('is-on'); setTimeout(function () { if (old !== curImg) old.classList.remove('is-live'); }, 1200); }
    }
    function badges() {
      var g = G[gi], f = F[fi];
      var fin = f.tech === 'aea' ? ['finish', INFO.aea.t, 'aea'] : ['finish', INFO.pvd.t, 'pvd'];
      if (g.kind === 'tap') return [['cart', INFO.cart.t, 'cart'], ['life', INFO.life.t, 'life'], fin];
      if (g.kind === 'shower') return [['life', INFO.life.t, 'life'], fin, ['match', INFO.match.t, 'match']];
      return [fin, ['match', INFO.match.t, 'match'], ['stock', INFO.stock.t, 'stock']];
    }
    function renderBadges() {
      var b = badges(), key = G[gi].kind + F[fi].tech;
      if (key !== badgeKey) {
        badgeKey = key;
        feats.innerHTML = b.map(function (x) {
          return '<button type="button" class="md-chip" aria-expanded="' + (openId === x[2]) + '" aria-controls="' + pop.id + '" data-id="' + x[2] + '">' + ICON[x[0]] + '<span><b>' + x[1] + '</b></span>' + CARET + '</button>';
        }).join('');
        [].forEach.call(feats.children, function (c) { c.addEventListener('click', function (e) { e.stopPropagation(); togglePop(c.dataset.id, c); }); });
        if (openId && !b.some(function (x) { return x[2] === openId; })) closePop();
      }
      [].forEach.call(feats.children, function (c, j) { c.classList.toggle('is-hi', j === hiStep % b.length); });
      hiStep++;
    }
    function setFinish(i, changedFinish) {
      var prev = fi; fi = i; elapsed = 0; t0 = performance.now();
      var f = F[i], arr = list();
      if (!arr.length) return;
      if (pi >= arr.length) pi = 0;
      var it = arr[pi];
      showImg(it.img);
      railBtns.forEach(function (b, j) { b.setAttribute('aria-current', j === i); });
      keepVisible(rail, railBtns[i]);
      stage.style.backgroundColor = f.tint;
      if (changedFinish || prev !== i || !lastFn) {
        var n = document.createElement('div'); n.className = 'md-fn is-in'; n.textContent = f.name; fwrap.appendChild(n);
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          n.classList.remove('is-in');
          if (lastFn) { var o = lastFn; o.classList.add('is-out'); setTimeout(function () { o.remove(); }, 750); }
          lastFn = n;
        }); });
      }
      curItem = it; if (plink) plink.href = it.url;
      q('[data-md-type]').textContent = it.name;
      q('[data-md-p]').textContent = money.format(it.price / 100);
      var hasCmp = it.compare && it.compare > it.price;
      q('[data-md-r]').textContent = hasCmp ? money.format(it.compare / 100) : '';
      q('[data-md-off]').textContent = hasCmp ? Math.round((1 - it.price / it.compare) * 100) + '% off RRP' : '';
      shop.textContent = 'Shop ' + f.name; shop.href = f.url;
      sampleBtn.classList.remove('is-done');
      sampleBtn.textContent = f.sample ? 'Add a free ' + f.name + ' sample' : cfg.sampleBoxLabel;
      renderBadges();
      setBar(0);
    }
    function setGroup(i) {
      gi = i; pi = 0;
      segBtns.forEach(function (b, j) { b.setAttribute('aria-selected', j === i); });
      movePill(); keepVisible(seg, segBtns[i]);
      q('[data-md-lede]').textContent = G[i].lede;
      badgeKey = '';
      loadGroup(i).then(function () { if (gi === i) { ready = true; setFinish(fi, true); } });
    }
    function advance() {
      var n = list().length;
      if (pi < n - 1) { pi++; setFinish(fi); } else { pi = 0; setFinish((fi + 1) % F.length, true); }
    }
    function setPlay(on) {
      playing = on; t0 = performance.now() - elapsed;
      toggle.setAttribute('aria-label', on ? 'Pause the loop' : 'Play the loop');
      toggle.querySelector('svg').innerHTML = on ? PAUSE : PLAY;
      if (!on) setBar(1);
    }
    function togglePop(id, btn) {
      if (openId === id) { closePop(); return; }
      var i = INFO[id]; openId = id;
      pop.querySelector('h4').textContent = i.t;
      pop.querySelector('p').textContent = i.p;
      var a = pop.querySelector('a');
      if (i.a && i.href) { a.hidden = false; a.textContent = i.a; a.href = i.href; } else { a.hidden = true; }
      pop.style.left = Math.max(12, Math.min(btn.offsetLeft, stage.clientWidth - pop.offsetWidth - 22)) + 'px';
      pop.classList.add('is-open');
      [].forEach.call(feats.children, function (c) { c.setAttribute('aria-expanded', c.dataset.id === id); });
      if (playing) { wasPlaying = true; setPlay(false); }
    }
    function closePop() {
      if (!openId) return;
      openId = null; pop.classList.remove('is-open');
      [].forEach.call(feats.children, function (c) { c.setAttribute('aria-expanded', 'false'); });
      if (wasPlaying) { wasPlaying = false; setPlay(true); }
    }

    toggle.addEventListener('click', function () { setPlay(!playing); });
    pop.querySelector('.md-pop-x').addEventListener('click', closePop);
    document.addEventListener('click', function (e) { if (openId && !pop.contains(e.target)) closePop(); });
    stage.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePop(); });
    stage.addEventListener('mouseenter', function () { hover = true; elapsed = performance.now() - t0; });
    stage.addEventListener('mouseleave', function () { hover = false; t0 = performance.now() - elapsed; });
    window.addEventListener('resize', movePill);

    // Clicking the product opens it.
    view.addEventListener('click', function () { if (curItem) window.location.href = curItem.url; });

    sampleBtn.addEventListener('click', function () {
      var f = F[fi];
      if (!f.sample) { window.location.href = cfg.sampleBoxUrl; return; }
      sampleBtn.disabled = true;
      fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(f.sample), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        sampleBtn.innerHTML = f.name + ' sample added. <a href="' + root + 'cart">View cart</a>';
        sampleBtn.classList.add('is-done');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        return fetch(root + 'cart.js').then(function (c) { return c.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span').forEach(function (n) { n.textContent = cart.item_count; });
        });
      }).catch(function () {
        sampleBtn.textContent = 'Could not add the sample. Please try again';
      }).finally(function () { sampleBtn.disabled = false; });
    });

    function frame(now) {
      if (ready && playing && !hover && onScreen && !document.hidden) {
        elapsed = now - t0;
        var n = list().length || 1, k = Math.min(elapsed / DUR, 1);
        setBar((pi + k) / n);
        if (k >= 1) advance();
      }
      requestAnimationFrame(frame);
    }

    // Start loading only when the section is close to the screen.
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      if (e.isIntersecting && !started) {
        started = true; setGroup(0); setPlay(playing); requestAnimationFrame(frame);
      }
    }, { rootMargin: '400px 0px' });
    io.observe(el);
    var vis = new IntersectionObserver(function (entries) {
      onScreen = entries[0].isIntersecting;
      if (onScreen) t0 = performance.now() - elapsed;
    }, { threshold: 0.15 });
    vis.observe(stage);
  }

  function boot() { document.querySelectorAll('[data-mimi-discover]').forEach(function (el) { if (!el.dataset.mdInit) { el.dataset.mdInit = '1'; init(el); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();